import { Fragment } from 'react'

import { Section, SubTitle } from '@/components/ArticleElement'
import PoliciesLayout from '@/components/Layouts/PoliciesLayout'
import { useLanguage } from '@/hooks/Contexts'

const CookiePolicy = () => {
  const {
    cookie_policy: { descr, titles, paragraphs },
  } = useLanguage()

  return (
    <PoliciesLayout title='cookie_policy'>
      <p className='text-sm'>{descr}</p>
      {titles.map((title, i) => (
        <Fragment key={i}>
          <SubTitle extraCls='mt-4'>{title}</SubTitle>
          <Section paragraphs={paragraphs[i]} paragraphCls='mt-2' />
        </Fragment>
      ))}
    </PoliciesLayout>
  )
}

export default CookiePolicy
